import { ROBINHOOD_CHAIN } from '@fukemon/shared';
import { http } from 'viem';
import { createConfig } from 'wagmi';
import { injected, walletConnect } from 'wagmi/connectors';

const walletConnectProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string | undefined;

const connectors = [
  injected({ shimDisconnect: true }),
  ...(walletConnectProjectId
    ? [
        walletConnect({
          projectId: walletConnectProjectId,
          metadata: {
            name: 'FUKÉMON: Market Mayhem',
            description: 'Oracle-powered monster battles on Robinhood Chain',
            url: typeof window === 'undefined' ? 'https://fukemon.game' : window.location.origin,
            icons: []
          },
          showQrModal: true
        })
      ]
    : [])
];

export const wagmiConfig = createConfig({
  chains: [ROBINHOOD_CHAIN],
  connectors,
  transports: {
    [ROBINHOOD_CHAIN.id]: http(
      (import.meta.env.VITE_ROBINHOOD_RPC_URL as string | undefined) ??
        ROBINHOOD_CHAIN.rpcUrls.default.http[0]
    )
  }
});

